export const useForm = (form: Ref<HTMLFormElement | null>) => {
    const formValues = ref<Record<string, any>>({});
    const formErrors = ref<Record<string, string>>({});

    // TODO: maybe a dirty check in the future and a way to reset (if multipage)?
    // const formDirty = ref(false);
    const formValid = ref(false);
    watch(
        formValues,
        () => {
            // formDirty.value = true;
            formValid.value = form.value?.checkValidity?.() ?? false;
        },
        { deep: true },
    );

    const checkInputValid = (input: HTMLInputElement | HTMLTextAreaElement) => {
        const isInvalid = !input.validity.valid;
        const id = input.id;
        if (id) {
            formErrors.value[id] = input.validationMessage;
        }
        return isInvalid;
    };

    const handleBlur = (ev: FocusEvent) => {
        checkInputValid(ev.target as HTMLInputElement);
    };
    const handleInput = (ev: InputEvent) => {
        const input = ev.target as HTMLInputElement;
        if (input.id in formErrors.value && formErrors.value[input.id]) checkInputValid(input);
    };

    // TODO: maybe focus first invalid input?
    const checkFormValid = () => {
        const _form = unref(form);
        if (_form) {
            // All extra validations
            _form.checkValidity();
            const formFields = Array.from(_form.querySelectorAll('input, textarea')) as (HTMLInputElement | HTMLTextAreaElement)[];
            if (!formFields.length) return false;
            let haveInvalid = false;

            formFields.forEach((input) => {
                const isInvalid = checkInputValid(input);
                haveInvalid = haveInvalid || isInvalid;
            });

            return !haveInvalid;
        }

        return true;
    };
    return {
        // formDirty,
        formValid,
        formValues,
        formErrors,
        checkFormValid,
        checkInputValid,
        handleBlur,
        handleInput,
    };
};
